import { useCityConfig } from "city/cityConfig";

export function isPayoneIntegrationEnabled() {
  const config = useCityConfig();

  return config.PAYONE_INTEGRATION_ENABLED;
}
